import { IDocumentListItem, DocumentListItem, IDocumentListParentItem, DocumentListParentItem } from "./documentListItem";
import { IDocumentCompanyListItem, DocumentCompanyListItem } from "./documentCompanyListItem";

export interface IDocumentList {
    hasMore: boolean;
    page: number;
    companyId: string;
    parent: IDocumentListParentItem;
    items: IDocumentListItem[];
    favoriteIds: string[];
    companies: IDocumentCompanyListItem[];
    sortColumn: string;
    sortOrderIsAsc: boolean;
}

export class DocumentList implements IDocumentList {
    hasMore: boolean;
    page: number;
    companyId: string;
    parent: DocumentListParentItem;
    items: DocumentListItem[];
    favoriteIds: string[];
    companies: DocumentCompanyListItem[];
    sortColumn: string;
    sortOrderIsAsc: boolean;

    constructor();
    constructor(obj: IDocumentList);
    constructor(obj?: any) {
        this.hasMore = obj && obj.hasMore || false;
        this.page = obj && obj.page || 1;
        this.sortColumn = obj && obj.sortColumn || "";
        this.sortOrderIsAsc = obj && obj.sortOrderIsAsc || false;
        this.companyId = obj && obj.companyId || "";
        this.parent = new DocumentListParentItem(obj && obj.parent || null);
        this.items = [];
        if (obj && obj.items) {
            for (let i = 0; i < obj.items.length; i++) {
                this.items.push(new DocumentListItem(obj.items[i]));
            }
        }
        this.favoriteIds = [];
        if (obj && obj.favoriteIds) {
            for (let i = 0; i < obj.favoriteIds.length; i++) {
                this.favoriteIds.push(obj.favoriteIds[i]);
            }
        }
        this.companies = [];
        if (obj && obj.companies) {
            for (let i = 0; i < obj.companies.length; i++) {
                this.companies.push(new DocumentCompanyListItem(obj.companies[i]));
            }
        }
    }
}